import { render, staticRenderFns } from "./addBarCode.vue?vue&type=template&id=620bfe03&scoped=true&"
import script from "./addBarCode.vue?vue&type=script&lang=js&"
export * from "./addBarCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620bfe03",
  null
  
)

export default component.exports